module.exports = __webpack_public_path__ + "static/media/Worried.4af16f23.png";